import {Component, OnInit} from '@angular/core';

@Component({
	selector: 'data-table-container',
	templateUrl: './data-table-container.component.html',
	styleUrls: ['./data-table-container.component.scss']
})
export class DataTableContainerComponent implements OnInit {

	constructor() {
	}

	ngOnInit() {
	}

}
